import React from 'react';

const Meta = ({ Valor_Meta }) => {
  // Verifica se há dados válidos
  if (!Valor_Meta || Object.keys(Valor_Meta).length === 0) {
    return <div></div>;
  }

  // Obtém a chave principal e seu valor
  const metaKey = Object.keys(Valor_Meta)[0];
  const metaValue = Valor_Meta[metaKey];

  // Caso "Meta": quando o valor for uma string (ex.: {"Meta": "R$ 200.00 mi"})
  if (typeof metaValue === 'string') {
    return (
      <div className="mt-auto d-flex align-items-end justify-content-end">
        <span className="titleMeta">{metaKey}</span>
        <span className="valorMeta">{metaValue}</span>
      </div>
    );
  }

  // Caso "Metas": quando o valor for um objeto (ex.: {"Metas": { ... }})
  if (typeof metaValue === 'object' && metaValue !== null) {
    return (
      <div className="metas-bar d-flex justify-content-between align-items-center px-3 py-2">
        <span className="titleMeta">{metaKey}</span>
        <span className="valorMeta">
          {Object.keys(metaValue).map((chave, index, arr) => (
            <React.Fragment key={chave}>
              <strong>{chave}</strong> {metaValue[chave]}
              {index < arr.length - 1 && " | "}
            </React.Fragment>
          ))}
        </span>
      </div>
    );
  }

  // Fallback para casos inesperados
  return <div></div>;
};

export default Meta;